import { AxiosError } from 'axios'
import { ENDPOINTS } from 'constants/endpoints'
import apiInstance from 'services/api/instance'

import { handleErrorMessage } from '../errors'

export const uploadReturnedReceipt = async (
  id: string,
  file: File,
): Promise<void> => {
  try {
    const formData = new FormData()
    formData.append('file', file)
    await apiInstance.post(
      ENDPOINTS.FINANCIAL_MOVEMENTS.RETURNED_RECEIPT(id),
      formData,
    )
  } catch (error) {
    const axiosError = error as AxiosError
    return Promise.reject(handleErrorMessage({ axiosError }))
  }
}

export const getReturnedReceipt = async (id: string): Promise<Blob> => {
  try {
    const response = await apiInstance.get(
      ENDPOINTS.FINANCIAL_MOVEMENTS.RETURNED_RECEIPT(id),
      { responseType: 'blob' },
    )
    return response.data as Blob
  } catch (error) {
    const axiosError = error as AxiosError
    return Promise.reject(handleErrorMessage({ axiosError }))
  }
}

export const deleteReturnedReceipt = async (id: string): Promise<void> => {
  try {
    await apiInstance.delete(ENDPOINTS.FINANCIAL_MOVEMENTS.RETURNED_RECEIPT(id))
  } catch (error) {
    const axiosError = error as AxiosError
    return Promise.reject(handleErrorMessage({ axiosError }))
  }
}
